export const AUTH_EXPIRED_EVENT = "anna-auth-expired";

const SENSITIVE_STORAGE_KEYS = new Set([
  "anna_token",
  "anna_user",
  "anna_user_status",
  "anna_sessions_cache",
  "anna_chat_draft",
  "anna_activeSessionId",
  "anna_lastActivityTs",
  "doppelganger_activeSessionId",
  "doppelganger_lastActivityTs",
]);

const SENSITIVE_STORAGE_PREFIXES = ["anna_history_", "anna_chat_draft:"];

export function getTokenExpirationMs(token) {
  if (!token || typeof token !== "string") return null;
  try {
    const [payloadPart] = token.split(".");
    if (!payloadPart) return null;
    const base64 = payloadPart.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    const payload = JSON.parse(atob(padded));
    return Number.isFinite(payload.exp) ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

export function isTokenExpired(token, now = Date.now()) {
  const expiresAt = getTokenExpirationMs(token);
  return expiresAt === null || expiresAt <= now;
}

export function notifyAuthExpired(reason = "expired") {
  window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT, { detail: { reason } }));
}

export function clearSensitiveSessionStorage() {
  for (let index = localStorage.length - 1; index >= 0; index -= 1) {
    const key = localStorage.key(index);
    if (!key) continue;
    if (
      SENSITIVE_STORAGE_KEYS.has(key) ||
      SENSITIVE_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix))
    ) {
      localStorage.removeItem(key);
    }
  }
}